import moment from 'moment';
import range from 'lodash/range';
import { Injectable } from '@angular/core';
import { DeliveryCalendar } from '@cakeiteasy/web-ui';
import { dateHelper, IDeliveryCalendarDay, IOutletScheduleDay, ISchedule } from '@cakeiteasy/web-utils';
import { DeliveryApiService } from '../../api-services/services/delivery-api.service';

@Injectable({ providedIn: 'root' })
export class DeliveryAvailabilityService {

  static WEEKDAY_KEYS_INDEX_MAP = {
    'sunday': 0,
    'monday': 1,
    'tuesday': 2,
    'wednesday': 3,
    'thursday': 4,
    'friday': 5,
    'saturday': 6,
    '0': 'sunday',
    '1': 'monday',
    '2': 'tuesday',
    '3': 'wednesday',
    '4': 'thursday',
    '5': 'friday',
    '6': 'saturday'
  };

  constructor(private _api: DeliveryApiService) {
  }

  /** Probably, this method is useless, it should be investigated*/
  public getUntiedOutletCalendar(outletId: number,
                                 monthsCount: number,
                                 fromDate: Date,
                                 prevCalendar: DeliveryCalendar = null): Promise<DeliveryCalendar> {
    function caller(year, month) {
      return this._api.getUntiedOutletCalendar(outletId, year, month);
    }

    return this._getCalendar(caller.bind(this), monthsCount, fromDate, prevCalendar);
  }

  public getOutletCalendar(bakeryId: number,
                           outletId: number,
                           monthsCount: number,
                           fromDate: Date,
                           prevCalendar: DeliveryCalendar = null): Promise<DeliveryCalendar> {
    function caller(year, month) {
      return this._api.getOutletCalendar(bakeryId, outletId, year, month);
    }

    return this._getCalendar(caller.bind(this), monthsCount, fromDate, prevCalendar);
  }

  public getOrderOutletCalendar(orderId: number,
                                outletId: number,
                                monthsCount: number,
                                fromDate: Date,
                                prevCalendar: DeliveryCalendar = null): Promise<DeliveryCalendar> {
    function caller(year, month) {
      return this._api.getOrderOutletCalendar(orderId, outletId, year, month);
    }

    return this._getCalendar(caller.bind(this), monthsCount, fromDate, prevCalendar);
  }

  public getDeliveryCalendar(bakeryId: number,
                             postNumber: string,
                             monthsCount: number,
                             fromDate: Date,
                             prevCalendar: DeliveryCalendar = null): Promise<DeliveryCalendar> {
    function caller(year, month) {
      return this._api.getDeliveryCalendar(bakeryId, year, month, postNumber);
    }

    return this._getCalendar(caller.bind(this), monthsCount, fromDate, prevCalendar);
  }

  public getOrderDeliveryCalendar(orderId: number,
                                  postNumber: string,
                                  monthsCount: number,
                                  fromDate: Date,
                                  prevCalendar: DeliveryCalendar = null): Promise<DeliveryCalendar> {
    function caller(year, month) {
      return this._api.getOrderDeliveryCalendar(orderId, year, month, postNumber);
    }

    return this._getCalendar(caller.bind(this), monthsCount, fromDate, prevCalendar);
  }

  public getExternalDeliveryCalendar(data: {
    monthsCount: number,
    fromDate: Date,
    prevCalendar?: DeliveryCalendar,
    params?: { outletId?: number };
  }): Promise<DeliveryCalendar> {
    const { monthsCount, fromDate, prevCalendar = null, params } = data;

    const caller = (year, month): Promise<IDeliveryCalendarDay> => {
      return this._api.getExternalDeliveryCalendar({ year, month, ...params });
    };

    return this._getCalendar(caller, monthsCount, fromDate, prevCalendar);
  }

  validateDateAvailability(calendar: DeliveryCalendar, date: Date): boolean {
    if (!calendar) {
      return false;
    }

    const calendarDate = calendar.getDate(date);
    return !date || !calendarDate || !calendarDate.isActive;
  }

  private _getCalendar(apiCaller: (year, month) => Promise<IDeliveryCalendarDay>,
                       monthsCount: number,
                       fromDate: Date,
                       prevCalendar: DeliveryCalendar = null) {
    const current = moment(fromDate);
    let availabilityCalendar = prevCalendar ? prevCalendar : new DeliveryCalendar([]);

    const promises = [];
    for (let i = 0; i < monthsCount; i++) {
      promises.push(apiCaller(current.year(), current.month() + 1));
      current.add(1, 'month');
    }

    return Promise.all(promises).then((calendars) => {
      calendars.forEach(c => {
        availabilityCalendar.extend(c);
      });
      return availabilityCalendar;
    });
  }

  getTimeRangesForPickup(schedule: ISchedule<IOutletScheduleDay>, date: Date): string[] {
    const day = date.getDay();


    const workingDay = schedule[DeliveryAvailabilityService.WEEKDAY_KEYS_INDEX_MAP[day]];
    const oneHour = 60; // one hour minutes span

    const times = range(workingDay.openingHoursStart, workingDay.openingHoursEnd, oneHour);
    times.push(workingDay.openingHoursEnd);

    return times.reduce((result, value, index) => {
      if (index < times.length - 1) {
        result.push([times[index], times[index + 1]]);
      }

      return result;
    }, []).map(function (startEndArray) {
      return dateHelper.stringifyMinutesCount(startEndArray[0]) + ' - '
        + dateHelper.stringifyMinutesCount(startEndArray[1]);
    });
  }
}
